import { IJsonQuery } from '../../../packages/JsonQuery';
import { IOffer as IOfferDesktop } from '../../../packages/OfferCardWidget/packages/api-models/search-offers/v2/types';

import { IOfferForMobileSiteSchema as IOfferMobile } from 'shared/repositories/search-engine/entities/offer/OfferForMobileSiteSchema';
import { ICounters } from './counters';

interface IOffersCommon {
  /** Ссылка на выдачу с выбранными фильтрами **/
  allOffersLink?: string;
  /** Счётчик объявлений в доме по выбранным фильтрам **/
  counters: ICounters;
  /** Json Query. При первом запросе отдаём jsonquery в котором есть хотя бы одно объявлений для последующего поиска **/
  jsonQuery: IJsonQuery;
}

export type TOffers = IOffersDesktop | IOffersMobile;

export interface IOffersDesktop extends IOffersCommon {
  offers: IOfferDesktop[];
}

export interface IOffersMobile extends IOffersCommon {
  offers: IOfferMobile[];
}

export interface IOffersState<T> {
  data: T;
  status: EOffersStatus;
}

export enum EOffersStatus {
  Pending = 'pending',
  Ready = 'ready',
  Failed = 'Failed',
  Initial = 'initial',
}
